import './player.scss';

export class Player {
    constructor(target) {
        this.classes = {
            buttonToggle: 'player__toggle',
            volume: 'player__volume',
            list: 'player__list',
            listItem: 'list__item',
            timeProgress: 'player__time-progress',
            timeCurrent: 'player__time-current',
            timeDuration: 'player__time-duration',
            previous: 'player__previous',
            next: 'player__next',
            activeItem: 'is-active',
            playing: 'is-playing',
        };

        this.element        = $(target);
        this.body           = $(document.body);
        this.audio          = this.element.find('audio').get(0);
        this.playButton     = this.element.find(`.${this.classes.buttonToggle}`);
        this.volumeSlider   = this.element.find(`.${this.classes.volume}`);
        this.timeProgress   = this.element.find(`.${this.classes.timeProgress}`);
        this.timeCurrent    = this.element.find(`.${this.classes.timeCurrent}`);
        this.timeDuration   = this.element.find(`.${this.classes.timeDuration}`);
        this.previousButton = this.element.find(`.${this.classes.previous}`);
        this.nextButton     = this.element.find(`.${this.classes.next}`);
        this.list           = this.element.find(`.${this.classes.list}`);
        this.listItems      = this.list.find(`.${this.classes.listItem}`);

        this.isPlaying          = false;
        this.currentIndex       = 0;
        this.isDraggingProgress = false;
        this.isAudioLoaded      = false;
        this.isVisible          = false;
        this.defaultVolume      = 50;
        this.currentVolume      = parseInt(localStorage.getItem('player-volume')) || this.defaultVolume;

        this.init();
    }

    init() {
        if (this.element.hasClass('player--large') && this.listItems.length) {
            const firstTrackSrc = this.listItems.first().data('src');

            if (firstTrackSrc) {
                this.audio.src = firstTrackSrc;
            }
        }

        this.playButton.on('click', this.togglePlay.bind(this));

        this.audio.volume = this.currentVolume / 100;
        this.volumeSlider.val(this.currentVolume);
        this.volumeSlider.on('input change mousemove', this.updateVolume.bind(this));
        this.updateVolume({ target: this.volumeSlider[0] });

        $(document).on('player-volume-change', (event, volume) => {
            if (event.target !== this.element[0]) {
                this.audio.volume = volume / 100;
                this.volumeSlider.val(volume);
                this.updateRangeProgress(this.volumeSlider);
            }
        });

        this.updateRangeProgress(this.volumeSlider);

        this.previousButton.on('click', this.playPrevious.bind(this));
        this.nextButton.on('click', this.playNext.bind(this));

        // Time progress events - updated for better seek handling
        this.timeProgress
            .on('mousedown touchstart', () => {
                this.isDraggingProgress = true;
            })
            .on('mouseup touchend', () => {
                this.isDraggingProgress = false;
            })
            .on('input', (e) => {
                this.updateRangeProgress($(e.target));
                this.updateTimeFromProgress(e.target.value);
            })
            .on('change', (e) => {
                this.seekTime(e);
            });

        this.audio.addEventListener('timeupdate', this.updateTime.bind(this));
        this.audio.addEventListener('loadedmetadata', this.updateDuration.bind(this));
        this.audio.addEventListener('durationchange', this.updateDuration.bind(this));
        this.audio.addEventListener('ended', this.handleTrackEnd.bind(this));
        this.audio.addEventListener('play', () => {
            this.isPlaying = true;
            this.element.addClass(this.classes.playing);
            this.body.addClass(`onair-${this.classes.playing}`);
            this.playButton
                .attr('aria-pressed', true)
                .attr('title', window.ballers.text.pause);
        });

        this.audio.addEventListener('pause', () => {
            this.isPlaying = false;
            this.element.removeClass(this.classes.playing);
            this.body.removeClass(`onair-${this.classes.playing}`);
            this.playButton
                .attr('aria-pressed', false)
                .attr('title', window.ballers.text.listen);
        });

        this.audio.addEventListener('error', () => {
            console.log('Error code:', this.audio.error.code);
            console.log('Error message:', this.audio.error.message);
        });

        this.listItems.on('click', (e) => {
            const index = this.listItems.index(e.currentTarget);

            this.playTrack(index);
        });

        // Using keyboards prev/next keys to navigate through tracks
        if ('mediaSession' in navigator) {
            navigator.mediaSession.setActionHandler('previoustrack', () => {
                $('.tab-pane.active .js-player.player--large.lazyloaded').find('.player__previous').get(0).click();
            });

            navigator.mediaSession.setActionHandler('nexttrack', () => {
                $('.tab-pane.active .js-player.player--large.lazyloaded').find('.player__next').get(0).click();
            });
        }

        this.element.data('player', this);
    }

    initLazyLoading() {
        if (!this.isAudioLoaded) {
            const firstTrackSrc = this.listItems.length ? this.listItems.first().data('src') : $(this.audio).data('src');

            if (firstTrackSrc) {
                this.audio.src = firstTrackSrc;
                this.audio.load();
                this.isAudioLoaded = true;
                this.isVisible     = true;

                this.listItems
                    .removeClass(this.classes.activeItem)
                    .first()
                    .addClass(this.classes.activeItem);
            }
        }
    }

    loadAudioMetadata() {
        if (this.audio.readyState === 0) {
            this.audio.load();
        }
    }

    loadAudioData() {
        if (this.element.hasClass('player--large') && this.listItems.length) {
            const firstTrackSrc = this.listItems.first().data('src');

            if (firstTrackSrc) {
                this.audio.src = firstTrackSrc;
                this.loadAudioMetadata();
                this.isAudioLoaded = true;

                this.listItems
                    .removeClass(this.classes.activeItem)
                    .first()
                    .addClass(this.classes.activeItem);
            }
        }
    }

    playTrack(index) {
        // Pause all other players first
        $('.js-player').map((_, target) => {
            const playerInstance = $(target).data('player');

            if (playerInstance && playerInstance !== this && playerInstance.isPlaying) {
                playerInstance.pausePlayback();
            }
        });

        this.currentIndex = index;

        const item     = this.listItems.eq(index);
        const audioSrc = item.data('src');

        if (this.audio.src !== audioSrc) {
            this.audio.src = audioSrc;
            this.loadAudioMetadata();

            this.listItems
                .removeClass(this.classes.activeItem)
                .eq(index)
                .addClass(this.classes.activeItem);
        }

        const playPromise = this.audio.play();

        if (playPromise !== undefined) {
            playPromise
                .then(() => {
                    this.isPlaying = true;
                    this.element.addClass(this.classes.playing);
                    this.body.addClass(`onair-${this.classes.playing}`);
                    this.playButton
                        .attr('aria-pressed', true)
                        .attr('title', window.ballers.text.pause);
                })
                .catch((error) => {
                    console.warn('Playback failed:', error);
                    this.isPlaying = false;
                    this.element.removeClass(this.classes.playing);
                    this.body.removeClass(`onair-${this.classes.playing}`);
                });
        }
    }

    handleTrackEnd() {
        if (this.currentIndex > 0) {
            this.playNext();
        } else {
            this.isPlaying = false;
            this.element.removeClass(this.classes.playing);
            this.body.removeClass(`onair-${this.classes.playing}`);
            this.playButton
                .attr('aria-pressed', false)
                .attr('title', window.ballers.text.listen);
        }
    }

    playNext() {
        if (this.currentIndex > 0) {
            this.playTrack(this.currentIndex - 1);
        }
    }

    playPrevious() {
        if (this.currentIndex < this.listItems.length - 1) {
            this.playTrack(this.currentIndex + 1);
        }
    }

    setActiveTrack(index) {
        this.listItems
            .removeClass(this.classes.activeItem)
            .eq(index)
            .addClass(this.classes.activeItem);
    }

    updateTime() {
        if (this.isDraggingProgress) {
            return;
        }

        const current  = this.audio.currentTime || 0;
        const duration = this.audio.duration || 0;

        this.timeCurrent.text(this.formatTime(current));

        if (duration > 0) {
            const progress = (current / duration) * 100;

            this.timeProgress.val(progress);
            this.updateRangeProgress(this.timeProgress);
        }
    }

    updateTimeFromProgress(progressValue) {
        const duration = this.audio.duration || 0;

        if (duration > 0) {
            const time = (progressValue / 100) * duration;

            this.timeCurrent.text(this.formatTime(time));
        }
    }

    updateDuration() {
        const duration = this.audio.duration || 0;

        if (duration > 0) {
            this.timeDuration.text(this.formatTime(duration));
            this.timeProgress.val(0);
            this.updateRangeProgress(this.timeProgress);
        }
    }

    seekTime(event) {
        const value    = event.target.value;
        const duration = this.audio.duration || 0;

        if (duration > 0) {
            const newTime = (value / 100) * duration;

            // Only seek if the time actually changed
            if (Math.abs(this.audio.currentTime - newTime) > 0.1) {
                this.audio.currentTime = newTime;
            }

            this.updateRangeProgress($(event.target));
            this.updateTimeFromProgress(value);
        }
    }

    formatTime(seconds) {
        if (!seconds || isNaN(seconds)) {
            return '00:00';
        }
        const minutes          = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);

        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }

    togglePlay() {
        if (this.isPlaying) {
            this.pausePlayback();
        } else {
            // Pause other players first
            $('.js-player').map((_, target) => {
                const playerInstance = $(target).data('player');

                if (playerInstance && playerInstance !== this && playerInstance.isPlaying) {
                    playerInstance.pausePlayback();
                }
            });

            // If no track is selected yet, start with the first one
            if (!this.audio.src && this.listItems.length) {
                const firstTrackSrc = this.listItems.first().data('src');

                if (firstTrackSrc) {
                    this.audio.src    = firstTrackSrc;
                    this.currentIndex = 0;
                    this.loadAudioMetadata();

                    // Set active state for first item when it's loaded
                    this.listItems
                        .removeClass(this.classes.activeItem)
                        .first()
                        .addClass(this.classes.activeItem);
                }
            }

            const playPromise = this.audio.play();

            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        this.isPlaying = true;
                        this.element.addClass(this.classes.playing);
                        this.body.addClass(`onair-${this.classes.playing}`);
                        this.playButton
                            .attr('aria-pressed', true)
                            .attr('title', window.ballers.text.pause);
                    })
                    .catch((error) => {
                        console.warn('Playback failed:', error);
                        this.isPlaying = false;
                        this.element.removeClass(this.classes.playing);
                        this.body.removeClass(`onair-${this.classes.playing}`);
                    });
            }
        }
    }

    pausePlayback() {
        this.audio.pause();
        this.isPlaying = false;
        this.element.removeClass(this.classes.playing);
        this.body.removeClass(`onair-${this.classes.playing}`);
        this.playButton
            .attr('aria-pressed', false)
            .attr('title', window.ballers.text.listen);
    }

    updateVolume(event) {
        const value = event.target.value;

        this.currentVolume = value;
        localStorage.setItem('player-volume', value);

        this.audio.volume = value / 100;
        this.updateRangeProgress($(event.target));

        // Notify other players
        this.element.trigger('player-volume-change', [value]);
    }

    updateRangeProgress(target) {
        const value  = parseInt(target.val());
        const max    = parseInt(target.attr('max'));
        const min    = parseInt(target.attr('min'));
        let progress = ((value - min) / (max - min));

        progress = progress - 0.001; // Slight adjustment for visual accuracy

        target.css('background-image', `
        -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(${progress}, var(--on-air-theme-color)),
          color-stop(${progress}, var(--volume-background))
        )
      `);
    }
}

$(() => {
    $('.js-player').map(function() {
        const player = new Player(this);

        $(this).on('lazybeforeunveil', player.initLazyLoading.bind(player));
    });
});
